var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({},'el-button',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"fa fa-plus-square xs-mr-10"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }